import { onlineManager } from '@tanstack/react-query'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import z from 'zod/v4'
import { getBookingTransportationQueryOptions } from '@/queries/query'
import { queryKeys } from '@/queries/keys'

export const Route = createFileRoute(
  '/my-booking/refund/$id/$transportationId',
)({
  params: {
    parse: (params) => ({
      transportationId: z.string().trim().parse(params.transportationId),
    }),
    stringify: ({ transportationId }) => ({ transportationId }),
  },
  loader: ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return context.queryClient.ensureQueryData(
        getBookingTransportationQueryOptions(params.transportationId),
      )
    }
    return context.queryClient.getQueryData(
      queryKeys.booking.transportation(params.transportationId),
    )
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
